import { render, staticRenderFns } from "./StatisticsSalesDay.vue?vue&type=template&id=a30afa84&scoped=true&"
import script from "./StatisticsSalesDay.vue?vue&type=script&lang=js&"
export * from "./StatisticsSalesDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30afa84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a30afa84')) {
      api.createRecord('a30afa84', component.options)
    } else {
      api.reload('a30afa84', component.options)
    }
    module.hot.accept("./StatisticsSalesDay.vue?vue&type=template&id=a30afa84&scoped=true&", function () {
      api.rerender('a30afa84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Dashboard/StatisticsSalesDay.vue"
export default component.exports